<template>
	<!-- 轮播图 -->
	<div class="brodact_box">
		<el-carousel :height="`620px`" trigger="click" ref="carousel" arrow="never">
			<el-carousel-item v-for="item in ary" :key="item.Id">
				<div class="img" :style="`background-image: url('${url + item.Url}')`" @click="getGame(item, item.Id)"></div>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { postAjax } from "@/util/ajax.js";
import { SysKey } from "@/util/sysconfig";

export default {
	data() {
		return {
			ary: [], //轮播图数量
			url: SysKey("ImgServerUrl").SysValue, //图片地址
			startX: null,
			endX: null,
		};
	},
	created() {
		this.getCarouselImg();
	},
	methods: {
		checkSliderDirection(e) {
			if (e.type === "mousedown") {
				this.startX = e.x;
			} else {
				this.endX = e.x;
				let offset = this.endX - this.startX;
				this.changeSlider(offset);
			}
		},
		changeSlider(offset) {
			if (offset > 100) {
				this.$refs.carousel.prev();
			} else if (offset < -100) {
				this.$refs.carousel.next();
			}
		},
		// 获取轮播图
		getCarouselImg() {
			let url = "api/Sys/GetSysTurns?Divice=1";
			postAjax(url, 1)
				.then(data => {
					this.ary = data.Data;
				})
				.catch(err => {
					console.log("error ", err);
				});
		},
		// 三方页面
		getGame(item, id) {
			if (!item.Action) return;

			const url = "/api/ThirdGame/GetGameList?g=" + id + "&d=1";
			const data = {
				name: id === 2 ? "AG真人" : "",
				PIndex: 1,
				PSize: 1,
			};

			postAjax(url, data)
				.then(data => {
					if (data.IsSucess) {
						this.startGame(data.Data.rows[0]);
					}
				})
				.catch(err => {
					console.log("error ", err);
				});
		},
	},
};
</script>

<style lang="less" scoped>
.brodact_box {
	width: 100%;
	.img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		background-size: cover;
		background-repeat: no-repeat;
		max-width: 100%;
		background-position: center;
	}
	/deep/ .el-carousel__button {
		width: 10px;
		height: 10px;
		background-color: #222222;
		border-radius: 50%;
	}

	/deep/ .el-carousel__arrow i {
		font-size: 26px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/mainPage/Carousel.vue